import { call, put, takeLatest } from "redux-saga/effects";
import {
  REQUEST_HEALTH_CHECK,
  receiveApiData
} from "../actions/actions";
import { healthCheckApi } from "../../services/api/healthCheck";

function* healthCheck() {
    try {
      // do api call
      const {data} = yield call(healthCheckApi);
      if(data) yield put(receiveApiData({ status: 'OK', message: 'service is running' }));
      else  yield put(receiveApiData({ status: 'NOT OK', message: 'connection with api was not successful' }));
    } catch (e) { 
      yield put(receiveApiData({ status: 'NOT OK', message: 'connection with api was not successful' }));
    }
  }

  export function* healthCkeckSaga() {
    yield takeLatest(REQUEST_HEALTH_CHECK, healthCheck);
  }